export default __webpack_public_path__ + "static/media/gallery-wip-emitter-cover_03.8417b447.jpg";